import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Button, Typography, Modal, Form, Input, Upload, message, InputNumber, Progress, Alert, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { UserOutlined, InstagramOutlined, FacebookOutlined, TwitterOutlined, MailOutlined, YoutubeOutlined, BoldOutlined, SpotifyOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { FaDeezer } from 'react-icons/fa';
import { GrAppleMusic } from 'react-icons/gr';
import { SiAmazonmusic, SiApplemusic, SiAudiomack, SiYoutubemusic } from 'react-icons/si';
import { useDispatch, useSelector } from 'react-redux';
import { addArtist, deleteArtist, deletePictureFromStorage, editArtist, fetchArtists } from '../../actions/ArtistsActions';
import { uploadFile } from '../../actions/TalentSearchActions';
import ProgressiveImage from '../common/ProgressiveImage';

const { Title, Text } = Typography;



const Artists = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentArtist, setCurrentArtist] = useState(null);
  const [personalPic, setPersonalPic] = useState(null);

  const [uploading, setUploading] = useState(false);
  const [deleteImage, setDeleteImage] = useState(false);

  const { artists, success, error, loading } = useSelector(state => state.artists);

  const [form] = Form.useForm();

  // Progress state for uploads
  const [uploadProgress, setUploadProgress] = useState({
    personalPic: 0
  });


  // useEffect(() => {
  //   // if (artists?.length<1) {
  //     const unsubscribe = dispatch(fetchArtists());

  //     return () => {
  //       unsubscribe(); // Cleanup listener on unmount
  //     };
  //   // }
  // }, [dispatch,artists]);

  // Effect to clear fields after successful submission

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (success) {
      // Clear local states
      setPersonalPic(null);
      setCurrentArtist(null);
      setDeleteImage(false);
      setUploadProgress({
        personalPic: 0,
      });
      form.resetFields();

      // Optionally show a success message
      // message.success("Submission successful! Fields have been cleared.");
    }
  }, [success, form]);

  const openModal = (artist = null) => {
    setIsEditing(artist ? true : false);
    setCurrentArtist(artist);
    if (artist) {
      form.setFieldsValue({
        name: artist.name,
        username: artist.username,
        genre: artist.genre,
        bio: artist.bio,
        bioSw: artist.bioSw,
        email: artist.email,
        instagram: artist.instagram,
        facebook: artist.facebook,
        twitter: artist.twitter,
        youtube: artist.youtube,
        deezer: artist.deezer,
        appleMusic: artist.appleMusic,
        amazonMusic: artist.amazonMusic,
        youtubeMusic: artist.youtubeMusic,
        audioMack: artist.audioMack,
        boomPlay: artist.boomPlay,
        spotify: artist.spotify,
      });
    } else {
      form.resetFields();
    }
    setVisible(true);
  };

  const showDeleteConfirm = (artist) => {
    Modal.confirm({
      title: 'Are you sure you want to delete?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Yes, Delete',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        handleDelete(artist);
      },
      onCancel() {
        // console.log('Cancelled');
      },
    });
  };


  const handleDelete = (artist) => {
    dispatch(deleteArtist(artist));
  }

  const getExtension = (file) => {
    const fileName = file.name;
    const extension = fileName.split('.').pop(); // Gets the part after the last dot
    return extension;
  };

  const handleSubmit = (values) => {


    form
      .validateFields()
      .then(async () => {

        let uploadPromises = [];

        if (personalPic) {
          const personalPicUpload = uploadFile(personalPic.originFileObj, getExtension(personalPic.originFileObj), 'artists', (progress) => {
            setUploadProgress((prev) => ({ ...prev, personalPic: progress }));
          });
          uploadPromises.push(personalPicUpload);
        }

        try {
          setUploading(true);

          // Wait for all uploads to finish
          const uploadResults = await Promise.all(uploadPromises);

          setUploading(false);

          const newValues = {
            name: values.name || '',
            username: values.username || '',
            genre: values.genre || '',
            bio: values.bio || '',
            bioSw: values.bioSw || '',
            email: values.email || '',
            instagram: values.instagram || '',
            facebook: values.facebook || '',
            twitter: values.twitter || '',
            youtube: values.youtube || '',
            deezer: values.deezer || '',
            appleMusic: values.appleMusic || '',
            amazonMusic: values.amazonMusic || '',
            youtubeMusic: values.youtubeMusic || '',
            audioMack: values.audioMack || '',
            boomPlay: values.boomPlay || '',
            spotify: values.spotify || '',
          };




          if (isEditing) {

            const submissionDataEdit = {
              ...newValues,
              personalPicUrl: personalPic
                ? uploadResults[0]
                : deleteImage
                  ? ''
                  : currentArtist.personalPicUrl,
            };

            if (personalPic || deleteImage) {
              // Delete the OLD image, not the new one
              if (currentArtist.personalPicUrl) {
                dispatch(deletePictureFromStorage(currentArtist.personalPicUrl));
              }
            }

            dispatch(editArtist(submissionDataEdit.username, submissionDataEdit));
          } else {
            const submissionDataAdd = {
              ...newValues,
              personalPicUrl: personalPic ? uploadResults[0] : '',
            };
            dispatch(addArtist(submissionDataAdd));
          }



        } catch (error) {
          setUploading(false);
        }

      })
      .catch((errorInfo) => {
        // Scroll to the first error field smoothly
        form.scrollToField(errorInfo.errorFields[0].name);
      });



    setVisible(false);


  };



  const handleCancel = () => {
    setPersonalPic(null);
    setCurrentArtist(null);
    setDeleteImage(false);
    form.resetFields();

    setVisible(false);
  };

  // const handleImageUpload = (file) => {
  //   return false; // prevent auto upload, handle manually
  // };

  // const handleUploadSuccess = (info) => {
  //   // Upload and save the image, or handle the file manually here
  //   message.success('Image uploaded successfully');
  // };

  const onPersonalPicChange = ({ file }) => {
    if (file && file.type.startsWith("image/")) {
      setPersonalPic(file); // Save the selected file to state
    } else {
      message.error(`Please upload a valid image file!`);
    }
  };

  return (
    <div style={{ padding: '20px', backgroundColor: '#f5f5f5', minHeight: "100vh" }}>
      <div style={{
        background: 'white',
        border: '1px solid var(--primary)',
        justifyContent: 'space-evenly',
        display: 'flex',
        alignItems: 'center',

        // gap:'10px'
      }}>
        <span style={{ fontWeight: '500' }}>

          {artists?.length} Artist{artists?.length === 1 ? '' : 's'} Found
        </span>
        <Button
          type="primary"
          onClick={() => openModal()}
          style={{ marginTop: '5px', marginBottom: '5px' }}
        >
          Add Artist
        </Button>
      </div>
      {/* <Title level={2} style={{ color: '#059941', textAlign: 'center' }}>Artists Gallery</Title> */}

      {
        loading
          ?
          <Spin style={{ marginTop: '5vh', display: 'block' }} size='large' />
          :
          <Row gutter={16} justify="center">
            {artists?.map((artist) => (

              <Col xs={24} sm={12} md={8} lg={6} key={artist.id} style={{ marginBottom: '10vh', marginTop: '5vh', display: 'flex' }}>
                <Card
                  hoverable
                  cover={<Link to={`/artists/${artist.id}`} ><ProgressiveImage aspectRatio={1} key={artist.id} preview={false} alt={artist.name} src={artist.personalPicUrl} /></Link>}
                  style={{ width: 240, borderRadius: '8px', display: 'flex', flexDirection: 'column', justifyContent: '' }}
                >
                  <Link to={`/artists/${artist.id}`}>
                    <Card.Meta
                      avatar={<UserOutlined />}
                      title={artist.name}
                      description={`Genre: ${artist.genre}`}
                    />
                    <Text
                      className="truncated-text-3"
                      style={{
                        // display: 'block', 
                        marginTop: '10px',
                        color: '#666'
                      }}>{artist.bio}</Text>
                    {/* <Link to={`/artists/${artist.id}`}>
                <Button
                  type="primary"
                  style={{ backgroundColor: '#059941', marginTop: '10px' }}
                >
                  View Profile
                </Button>
              </Link> */}
                  </Link>
                  <div
                    style={{ marginTop: '10px', width: '100%', display: 'flex', flexDirection: 'row', gap: 10 }}
                  >
                    <Button
                      type="default"
                      onClick={() => openModal(artist)}
                      style={{ flex: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      icon={<DeleteOutlined />}
                      type="default"
                      onClick={() => showDeleteConfirm(artist)}
                      danger
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
      }


      {/* Modal for Adding or Editing Artist */}
      <Modal
        title={isEditing ? 'Edit Artist' : 'Add Artist'}
        visible={visible}
        onCancel={handleCancel}
        onOk={form.submit}
        footer={null}
        width={600}
      >
        <Form
          form={form}
          onFinish={handleSubmit}
          layout="vertical"
          scrollToFirstError
        // initialValues={{
        //   social: {email:'', instagram: '', facebook: '', twitter: '',youtube:'', deezer:'', appleMusic:'', audioMack:'', boomPlay:'', spotify:'' },
        // }}
        >
          <Form.Item
            label="Artist Name"
            name="name"
            rules={[{ required: true, message: 'Please input the artist name!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: 'Please input the unique username!' }]}
          >
            <Input
              disabled={isEditing}
            />
          </Form.Item>

          <Form.Item
            label="Genre"
            name="genre"
            rules={[{ required: true, message: 'Please input the artist genre!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Biography"
            name="bio"
            rules={[{ required: true, message: 'Please input the artist biography!' }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item
            label="Swahili Biography"
            name="bioSw"
            rules={[{ required: true, message: 'Please input the artist biography (swahili version)!' }]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>

          <Form.Item label="Profile Picture" >
            {(!personalPic && currentArtist?.personalPicUrl && !deleteImage) && (
              <div style={{ marginTop: 16 }}>
                <img
                  src={currentArtist?.personalPicUrl}
                  alt="Personal Pic"
                  style={{ width: "150px", borderRadius: "4px" }}
                />
                <div>
                  <Button danger onClick={() => setDeleteImage(true)} icon={<DeleteOutlined />}>Delete</Button>
                </div>
              </div>
            )}
            {(!personalPic && deleteImage) && (
              <div style={{ marginTop: 16 }}>
                <div>
                  <Button danger onClick={() => setDeleteImage(false)} icon={<DeleteOutlined />}>Undo Delete</Button>
                </div>
              </div>
            )}
            <Upload
              listType="picture"
              showUploadList={false}
              onChange={onPersonalPicChange}
              // beforeUpload={(file) => file.type.startsWith('image/')}
              beforeUpload={(file) => {
                if (!file.type.startsWith("image/")) {
                  return false;
                }
                return true; // Allow upload to trigger onChange
              }}
            >
              <div>
                <Button icon={<UserOutlined />}>Upload</Button>
              </div>
            </Upload>
            {personalPic && (
              <div style={{ marginTop: 16 }}>
                <img
                  src={URL.createObjectURL(personalPic.originFileObj)}
                  alt="Personal Pic"
                  style={{ width: "150px", borderRadius: "4px" }}
                />
                <div>
                  <Button danger onClick={() => setPersonalPic(null)} icon={<DeleteOutlined />}>Remove</Button>
                </div>
              </div>
            )}
            {uploading &&
              uploadProgress.personalPic > 0 && (
                <Progress percent={uploadProgress.personalPic} />
              )}
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="Email Address"
            />
          </Form.Item>

          <Form.Item
            label="Instagram"
            name="instagram"
          >
            <Input
              prefix={<InstagramOutlined />}
              placeholder="Instagram Link"
            />
          </Form.Item>

          <Form.Item
            label="Facebook"
            name="facebook"
          >
            <Input
              prefix={<FacebookOutlined />}
              placeholder="Facebook Link"
            />
          </Form.Item>

          <Form.Item
            label="Twitter"
            name="twitter">
            <Input
              prefix={<TwitterOutlined />}
              placeholder="Twitter Link"
            />
          </Form.Item>

          <Form.Item
            label="Youtube"
            name="youtube"
          >
            <Input
              prefix={<YoutubeOutlined />}
              placeholder="Youtube Link"
            />
          </Form.Item>

          <Form.Item
            label="Youtube Music"
            name="youtubeMusic"
          >
            <Input
              prefix={<SiYoutubemusic />}
              placeholder="Youtube Music Link"
            />
          </Form.Item>

          <Form.Item
            label="Deezer"
            name="deezer"
          >
            <Input
              prefix={<FaDeezer />}
              placeholder="Deezer Link"
            />
          </Form.Item>

          <Form.Item
            label="Apple Music"
            name="appleMusic"
          >
            <Input
              prefix={<SiApplemusic />}
              placeholder="Apple Music Link"
            />
          </Form.Item>

          <Form.Item
            label="Amazon Music"
            name="amazonMusic"
          >
            <Input
              prefix={<SiAmazonmusic />}
              placeholder="Amazon Music Link"
            />
          </Form.Item>

          <Form.Item
            label="Audio Mack"
            name="audioMack"
          >
            <Input
              prefix={<SiAudiomack />}
              placeholder="Audio Mack Link"
            />
          </Form.Item>

          <Form.Item
            label="Boom Play"
            name="boomPlay"
          >
            <Input
              prefix={<BoldOutlined />}
              placeholder="Boom Play Link"
            />
          </Form.Item>

          <Form.Item
            label="Spotify"
            name="spotify"
          >
            <Input
              prefix={<SpotifyOutlined />}
              placeholder="Spotify Link"
            />
          </Form.Item>

          <Button type="primary" htmlType="submit" style={{ backgroundColor: '#059941' }}>
            {isEditing ? 'Update Artist' : 'Add Artist'}
          </Button>
        </Form>
        {/* 
        {success &&
          <Alert
            message={`Success`}
            type="success"
            showIcon
            description={`Artist created/updated successfully`}
            style={{ marginTop: 5, marginBottom: 5 }}
            closable
          />
        }
        {error &&
          <Alert
            message={`Failure`}
            type="error"
            showIcon
            description={`Error: ${error}`}
            style={{ marginTop: 5, marginBottom: 5 }}
            closable
          />
        } */}
      </Modal>
    </div>
  );
};

export default Artists;
